import React from 'react';

import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

import './view.less';
const View = ({ content, data }) => {
  return (
    <div className="block gridColumnBlocksForm">
      <RenderBlocks content={{ ...content, ...data }} />
    </div>
  );
};

export default View;
